import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { signOut } from "../redux/actions/auth.actions";
import { Button } from "./Button";
import { RootState } from "../redux/reducers/root.reducer";
import { AuthState } from "../redux/reducers/auth.reducer";

import {
  Home as HomeIcon,
  X as CloseIcon,
  Archive as ArchiveIcon,
  CreditCard as CardIcon,
  BarChart2 as ChartIcon,
  Bell as AlertIcon,
  Icon,
} from "react-feather";
import { isBefore } from "date-fns";

interface MenuItem {
  label: string;
  action: VoidFunction;
  Icon: Icon;
}

interface Props {
  onClose: VoidFunction;
}

export const OffererMenu: React.FC<Props> = ({ onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector<RootState, AuthState>(
    (state) => state.authReducer
  );

  const menuItems = useMemo<MenuItem[]>(
    () => [
      {
        label: "Inicio",
        action: () => {
          navigate("/solicitudesActivas");
        },
        Icon: HomeIcon,
      },
      {
        label: "Mis Ofertas",
        action: () => {
          navigate("/oferente/ofertasRealizadas");
        },
        Icon: ArchiveIcon,
      },
      {
        label: "Mis Transacciones",
        action: () => {
          navigate("/oferente/transacciones");
        },
        Icon: CardIcon,
      },
      ...(isBefore(new Date(), user?.FechaPremium?.toDate())
        ? [
            {
              label: "Módulo Estadísticas",
              action: () => {
                navigate("/oferente/estadisticas");
              },
              Icon: ChartIcon,
            },
            {
              label: "Módulo Alertas",
              action: () => {
                navigate("/oferente/alertas");
              },
              Icon: AlertIcon,
            },
          ]
        : []),
      {
        label: "Cerrar Sesión",
        action: () => {
          dispatch(signOut());
          navigate("/inicio");
        },
        Icon: CloseIcon,
      },
    ],
    // eslint-disable-next-line
    [user]
  );

  return (
    <React.Fragment>
      <Button
        text={"Mi Cuenta"}
        color="secondary"
        insideClassName="py-1 px-5"
        className="mb-4 mt-1"
        onClick={() => {
          navigate("/oferente/adminCuenta");
          onClose();
        }}
      />
      <ul className="list-none w-full">
        {menuItems.map((item, index) => (
          <li
            key={`plaintiff-menu-${index}`}
            className="h-10 flex pointer hover:bg-gray-500 hover:bg-opacity-20 w-full px-4 items-center cursor-pointer"
            onClick={() => {
              item.action();
              onClose();
            }}
          >
            <item.Icon size={26} color="white" strokeWidth={1.5} />
            <span className="text-sm text-white font-semibold ml-5">
              {item.label}
            </span>
          </li>
        ))}
      </ul>
    </React.Fragment>
  );
};
